/* RF_CHECKOUT_LOCK_MANAGER_BEGIN
 * Bundled identically into both entry scripts: no new loading-order dependency.
 * A gate releases only its own reason. Native disabled/ARIA state is restored
 * only after every registered reason has cleared. No cart data or writes.
 */
(function () {
  'use strict';
  if (window.RFCheckoutLocks) return;
  var states = {}, baselines = new WeakMap(), ownMutations = new WeakMap(), observer;
  var reloadRequired = window.__rfCartAddonLock === true;
  var selector = '[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]';
  function isBlocked() { return reloadRequired || Object.keys(states).some(function (key) { return states[key]; }); }
  function writeAttribute(el, name, value) {
    var old = el.getAttribute(name); if (old === value) return;
    var queue = ownMutations.get(el) || []; queue.push({name: name, old: old, value: value}); ownMutations.set(el, queue);
    if (value === null) el.removeAttribute(name); else el.setAttribute(name, value);
  }
  function rememberExternal(records) {
    records.forEach(function (record, index) {
      if (record.type !== 'attributes') return;
      var el = record.target, name = record.attributeName, value = el.getAttribute(name);
      for (var next = index + 1; next < records.length; next++) {
        if (records[next].target === el && records[next].attributeName === name) { value = records[next].oldValue; break; }
      }
      var queue = ownMutations.get(el) || [], own = queue.findIndex(function (entry) { return entry.name === name && entry.old === record.oldValue && entry.value === value; });
      if (own >= 0) { queue.splice(own, 1); return; }
      var baseline = baselines.get(el); if (!baseline) return;
      if (name === 'disabled') baseline.disabled = value !== null;
      if (name === 'aria-disabled') baseline.aria = value;
    });
  }
  function apply() {
    var blocked = isBlocked();
    document.querySelectorAll(selector).forEach(function (el) {
      if (blocked && !baselines.has(el)) baselines.set(el, {disabled: !!el.disabled, aria: el.getAttribute('aria-disabled')});
      Object.keys(states).forEach(function (scope) {
        var marker = 'data-rf-' + scope + '-blocked';
        if (states[scope]) { if (el.getAttribute(marker) !== '1') el.setAttribute(marker, '1'); }
        else if (el.hasAttribute(marker)) el.removeAttribute(marker);
      });
      if (blocked) {
        if ('disabled' in el) writeAttribute(el, 'disabled', '');
        writeAttribute(el, 'aria-disabled', 'true');
      } else if (baselines.has(el)) {
        var before = baselines.get(el); baselines.delete(el);
        if ('disabled' in el) writeAttribute(el, 'disabled', before.disabled ? '' : null);
        writeAttribute(el, 'aria-disabled', before.aria);
      }
    });
    if (reloadRequired && !document.getElementById('rf-checkout-reload-required')) {
      var host = document.querySelector('cart-items,mini-cart,form[action$="/cart"]');
      if (host) { var notice = document.createElement('p'); notice.id = 'rf-checkout-reload-required'; notice.setAttribute('role', 'alert'); notice.textContent = 'Bitte laden Sie die Seite neu, damit Ihr Warenkorb vollständig geprüft werden kann.'; host.prepend(notice); }
    }
  }
  window.RFCheckoutLocks = Object.freeze({
    set: function (scope, active) { if (!/^[a-z0-9-]{1,32}$/.test(scope)) throw new Error('Invalid checkout-lock scope'); if (observer) rememberExternal(observer.takeRecords()); states[scope] = !!active; apply(); },
    apply: apply, isBlocked: isBlocked, reloadRequired: reloadRequired
  });
  document.addEventListener('click', function (event) {
    if (isBlocked() && event.target.closest && event.target.closest(selector)) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('submit', function (event) {
    if (isBlocked() && event.target.matches && event.target.matches('form[action$="/cart"]') && (!event.submitter || event.submitter.name === 'checkout')) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  observer = new MutationObserver(function (records) { rememberExternal(records); apply(); });
  observer.observe(document.documentElement, {childList: true, subtree: true, attributes: true, attributeOldValue: true, attributeFilter: ['disabled', 'aria-disabled']});
  apply();
})();
/* RF_CHECKOUT_LOCK_MANAGER_END */

/* RepairFirst Cart-Add-on-Lock — Orphan-Cleanup
 * Entfernt verknüpfte Zusatzpositionen (_rf_addon), wenn ihr Eltern-Item (_rf_group == _rf_parent)
 * nicht mehr im Warenkorb ist. Die Controls dieser Zeilen werden bereits theme-seitig versteckt
 * (main-cart-items.liquid / header-mini-cart-content.liquid). Das hier ist die Server-Bereinigung.
 *
 * Hooks an das echte Theme-Pub/Sub (pubsub.js: window.subscribe, Events 'cart:update' etc.),
 * NICHT an DOM-Events (die feuert dieses Theme nicht). Plus einmalig beim Laden.
 *
 * WICHTIG (Fix 2026-07-29, "Reparatur laesst sich nicht entfernen"):
 * Das Theme entfernt Zeilen POSITIONSBASIERT (CartRemoveButton -> updateQuantity(dataset.index, 0)
 * -> /cart/change {line}). Wir entfernen per KEY ueber /cart/update.js. Dadurch verschieben sich
 * serverseitig alle Zeilennummern. Frueher wurde das ueber window.location.reload() geradegezogen,
 * der aber von einem 5s-Loop-Breaker unterdrueckt werden konnte -> das DOM behielt veraltete
 * data-index-Werte, und der naechste Entfernen-Klick loeschte die falsche Zeile.
 * Jetzt rendern wir stattdessen dieselben Sections nach, die das Theme selbst nachrendert
 * (getSectionsToRender/getSectionInnerHTML von <cart-items> bzw. <mini-cart>). Kein Reload,
 * kein Zeitfenster mit veralteten Indizes.
 */
(function () {
  'use strict';
  if (window.__rfCartAddonLock) return;
  window.__rfCartAddonLock = true;

  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  var busy = false;

  var mk61Blocked = false;
  function mk61Gate(cart) {
    var api = window.RFMk61Cart;
    var marked = !!(cart && Array.isArray(cart.items) && cart.items.some(function (item) { return (item.properties || {})._rf_contract === 'mk61-v1'; }));
    var state = api ? (cart ? api.inspect(cart) : { applicable: !!window.__rfMk61CartPresent, valid: false }) : { applicable: !!window.__rfMk61CartPresent || marked, valid: false, reason: 'unreadable' };
    mk61Blocked = !!(state.applicable && !state.valid);
    window.RFCheckoutLocks.set('mk61', mk61Blocked);
    var notice = document.getElementById('rf-mk61-cart-status');
    if (mk61Blocked && !notice) {
      var host = document.querySelector('cart-items') || document.querySelector('mini-cart');
      if (host) { notice = document.createElement('p'); notice.id = 'rf-mk61-cart-status'; notice.setAttribute('role', 'alert'); host.prepend(notice); }
    }
    if (notice) { notice.hidden = !mk61Blocked; notice.setAttribute('role', !cart ? 'status' : 'alert'); notice.textContent = !cart ? 'Ihr Warenkorb wird geprüft.' : state.reason === 'unreadable' ? 'Ihr Warenkorb konnte nicht geprüft werden. Bitte laden Sie die Seite neu und versuchen Sie es erneut.' : 'Bitte legen Sie die Reparatur erneut in den Warenkorb. Reparatur und Prüfung müssen gemeinsam bestellt werden.'; }
  }
  mk61Gate(null);
  document.addEventListener('click', function (event) {
    if (mk61Blocked && event.target.closest && event.target.closest('[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]')) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  document.addEventListener('submit', function (event) {
    if (mk61Blocked && event.target.matches && event.target.matches('form[action$="/cart"], form[action="/cart"]')) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);


  // Die Cart-UIs des Themes, die nach einer Mutation neu gerendert werden muessen.
  // <cart-items> = Warenkorbseite, <mini-cart> = Drawer. Beide bringen getSectionsToRender()
  // und getSectionInnerHTML() mit -> wir benutzen die Theme-eigene Logik statt eigener Selektoren.
  function cartEls() {
    var els = [document.querySelector('cart-items'), document.querySelector('mini-cart')];
    return els.filter(function (el) { return el && typeof el.getSectionsToRender === 'function'; });
  }
  function sectionsOf(el) {
    try { return el.getSectionsToRender() || []; } catch (e) { return []; } // Ziel-Section nicht im DOM
  }
  function sectionIds(els) {
    var out = [];
    els.forEach(function (el) {
      sectionsOf(el).forEach(function (s) {
        if (s && s.section && out.indexOf(s.section) < 0) out.push(s.section);
      });
    });
    return out;
  }
  function renderSections(els, state) {
    if (!state || !state.sections) return;
    els.forEach(function (el) {
      sectionsOf(el).forEach(function (s) {
        var host = document.getElementById(s.id);
        if (!host) return;
        var html = state.sections[s.section];
        if (typeof html !== 'string') return;
        var target = (s.selector && host.querySelector(s.selector)) || host;
        try { target.innerHTML = el.getSectionInnerHTML(html, s.selector); } catch (e) {}
      });
    });
  }

  function cleanup() {
    if (busy) return;
    busy = true; // SYNCHRON vor dem await setzen -> keine zwei parallelen Läufe

    fetch(root() + 'cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        mk61Gate(cart);
        var items = (cart && cart.items) || [];
        // Vorhandene Eltern-Gruppen (Nicht-Add-on-Zeilen mit _rf_group)
        var groups = {};
        items.forEach(function (it) {
          var p = it.properties || {};
          if (!p._rf_addon && p._rf_group) groups[p._rf_group] = true;
        });
        // Verwaiste Add-ons: _rf_addon gesetzt, aber Eltern-Gruppe fehlt
        var orphanKeys = items
          .filter(function (it) {
            var p = it.properties || {};
            return p._rf_addon && (!p._rf_parent || !groups[p._rf_parent]);
          })
          .map(function (it) { return it.key; });

        if (!orphanKeys.length) { busy = false; return; }

        // EIN atomarer /cart/update.js (statt N change.js) -> keine Key-Invalidierung zwischen Removes.
        // `sections` mitschicken: Shopify liefert das gerenderte HTML gleich mit zurueck, wir
        // tauschen es unten ein -> DOM-Zeilennummern bleiben mit dem Server synchron.
        var updates = {};
        orphanKeys.forEach(function (k) { updates[k] = 0; });

        var els = cartEls();
        var ids = sectionIds(els);
        var payload = { updates: updates };
        if (ids.length) {
          payload.sections = ids;
          payload.sections_url = window.location.pathname;
        }

        return fetch(root() + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(payload)
        })
          .then(function (r) { if (!r.ok) throw new Error('cart/update.js !ok'); return r.json(); })
          .then(function (updated) {
            // Verify: sind die Waisen wirklich weg? Wenn nicht -> DOM in Ruhe lassen.
            var stillThere = (updated.items || []).some(function (it) {
              return orphanKeys.indexOf(it.key) >= 0;
            });
            if (stillThere) { busy = false; return; }

            // Theme-Sections neu rendern. Bewusst OHNE publish(cartItemRemove): unsere eigene
            // Subscription haengt an diesen Events und wuerde sich selbst nochmal ausloesen.
            renderSections(els, updated);
            mk61Gate(updated);
            busy = false;
          });
      })
      .catch(function () { mk61Gate({ items: null }); busy = false; });
  }

  if (document.readyState !== 'loading') cleanup();
  else document.addEventListener('DOMContentLoaded', cleanup);

  // An das ECHTE Theme-Pub/Sub andocken (pubsub.js). Nach jeder Cart-Mutation prüfen.
  // ACHTUNG (Fix 2026-07-30): Dieses Script laedt per script_tag SYNCHRON, das Theme laedt
  // pubsub.aio.min.js mit `defer`. Beim Ausfuehren existiert window.subscribe also noch NICHT —
  // die frueher hier stehende if-Abfrage war immer false, die Subscription toter Code, und es
  // trugen ausschliesslich die setTimeout-Fallbacks weiter unten.
  // Deferred Scripts laufen VOR DOMContentLoaded, dort ist die Registrierung sicher; 'load' als
  // letzte Chance fuer Nachlader.
  var pubsubBound = false;
  function bindPubSub() {
    if (pubsubBound || typeof window.subscribe !== 'function') return pubsubBound;
    ['cart:update', 'cart:item-remove', 'cart:item-quantity-update'].forEach(function (ev) {
      window.subscribe(ev, function () { cleanup(); });
    });
    pubsubBound = true;
    return true;
  }
  if (!bindPubSub()) {
    document.addEventListener('DOMContentLoaded', function () {
      if (!bindPubSub()) window.addEventListener('load', bindPubSub);
    });
  }

  // FALLBACK-TRIGGER (2026-07-23, Nur-Addons-Bug): Pub/Sub allein reicht nicht — je nach
  // Theme-Version/Pfad wird Drawer-HTML per Section-Rendering injiziert (Scripts laufen dort
  // nicht) oder beim Entfernen feuert kein Event. Deshalb delegierte DOM-Trigger direkt an den
  // Cart-Controls + verzögerte Doppel-Prüfung (Theme-AJAX braucht einen Moment). `busy`-Gate
  // verhindert Parallel-Läufe; der Reload-Loop-Breaker (5s) bleibt unberührt.
  function scheduleCleanup() {
    setTimeout(cleanup, 1000);
    setTimeout(cleanup, 3000);
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('cart-remove-button, .button-cart-remove, .mini-cart-item-remove, a[href*="/cart/change"]')) scheduleCleanup();
    else if (t.closest('quantity-input button')) scheduleCleanup();
    else if (t.closest('a[href$="/cart"], .header-mini-cart, #cart-icon-bubble')) setTimeout(cleanup, 300); // Drawer/Cart öffnen -> Alt-Zustand prüfen
  }, true);
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('.quantity-input-field, input[name="updates[]"]')) scheduleCleanup();
  }, true);
})();
